export const TrackSubHeadList = ["ID", "제목", "가수", "권리사", "연관 트랙"];
export const TrackHeadList = [{ name: "소작품", colSpan: TrackSubHeadList.length }];
